<template>
  <Layout>
    <a :href="'/source/'" size="lg" class="color pointer"><i class="mdi mdi-arrow-left color me-2"></i>Retour</a>
    <PageHeader :title="title" :items="items" class="mt-2"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="outer-repeater" @submit.prevent="createSource">
              <div class="outer">
                <div class="outer">
                  <div class="mb-3">
                    <label for="formName">Nom :</label>
                    <input
                        id="formName"
                        type="text"
                        name="name"
                        class="form-control"
                        placeholder="Entrez le nom de la source..."
                        v-model="source.name"
                        :class="{
                    'is-invalid': submitted && $v.source.name.$error,
                    }"
                    />
                    <div
                        v-if="submitted && $v.source.name.$error"
                        class="invalid-feedback">
                      <span v-if="!$v.source.name.required">Ce champ est obligatoire.</span>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="formUrl">URL :</label>
                    <input
                        id="formUrl"
                        type="text"
                        name="url"
                        class="form-control"
                        placeholder="Entrez l'url de la source..."
                        v-model="source.url"
                        :class="{
                    'is-invalid': submitted && $v.source.url.$error,
                    }"
                    />
                    <div
                        v-if="submitted && $v.source.url.$error"
                        class="invalid-feedback">
                      <span v-if="!$v.source.url.required">Ce champ est obligatoire.</span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="float-end">
                <button type="reset" class="btn me-4 color-btn-reset pointer" @click.prevent="sourcePage">Annuler</button>
                <button type="submit" class="btn color-btn-submit pointer">Ajouter</button>
              </div>
            </form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
<script>

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {required} from "vuelidate/lib/validators";
import router from "@/router";
import Swal from "sweetalert2";

/**
 * Users component
 */
export default {
  name: 'add-source',
  page: {
    title: "AJOUTER UNE SOURCE",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "AJOUTER UNE SOURCE",
      items: [],
      currentPage: 1,
      totalPages: 0,
      submitted: false,
      source: {
        name: "",
        url: ""
      },
    };
  },
  validations: {
    source: {
      name: {
        required,
      },
      url: {
        required,
      },
    },
  },
  methods: {
    createSource() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.submitData();
      }
    },
    submitData:function() {
      this.$store.dispatch("source/createSource", this.source).then(
          (res) => {
            this.showAlert({
              icon: "success",
              title: "Ajoutée",
              text: "La source a été ajouté avec succès",
              confirmType: {
                type: "refreshSource",
              },
            });
          },
          (err) => {
            this.showAlert({
              icon: "error",
              title: "Non ajouté!",
              text: "Echec de ajout de source",
            });
          }
      );
    },
    /* Alerts */
    showAlert(data) {
      Swal.fire({
        icon: data.icon,
        title: data.title,
        text: data.text,
        confirmButtonColor: "#b1215c",
        showCancelButton: data.showCancelButton,
        confirmButtonText: data.confirmButtonText
            ? data.confirmButtonText
            : "OK",
        cancelButtonText: data.cancelButtonText,
      }).then((res) => {
        if (data.confirmType) {
          if (data.confirmType.type === "refreshSource") {
            if (!this.isLoading && res.isConfirmed) {
              router.go('/source/add-source');
            }
          }
        }
      });
    },
    sourcePage(){
      this.$router.push('/source');
    }
  },
  computed: {
    isLoading(){
      return this.$store.getters["source/getIsloading"];
    }
  },
};
</script>

<style scoped>
.color {
  color: #747C8D;
}

.color-btn-reset {
  background: #74788D 0 0 no-repeat padding-box;
  border: 1px solid #74788D;
  border-radius: 4px;
  color: #FFFFFF;
}

.color-btn-submit {
  background: #A23662 0 0 no-repeat padding-box;
  border: 1px solid #A23662;
  border-radius: 4px;
  color: #FFFFFF;
}
</style>
